/** Digits of a PIS (Programa de Integração Social) number. */
export const PIS_LENGTH = 11;

/**
 * Weights used to calculate the PIS (Programa de Integração Social) check digit.
 */
export const PIS_WEIGHTS = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
